<div class="app-sidebar sidebar-shadow bg-primary">
  <div class="scrollbar-sidebar">
    <div class="app-sidebar__inner">
      <ul class="vertical-nav-menu">
        <li class="app-sidebar__heading">Menu</li>
        <li>
          <a href="javascript:void(0);" (click)="goToPage('/dashboard')" [class.mm-active]="currentUrl.includes('/dashboard')">
            <i class="metismenu-icon pe-7s-rocket"></i> <span>Dashboard</span>
          </a>
        </li>

        <ng-container *ngIf="appState.isAdminOrSupervisor()">
          <li class="app-sidebar__heading">Production</li>
          <li>
            <a href="javascript:void(0);" (click)="goToPage('/live-activity')" [class.mm-active]="currentUrl.includes('/live-activity')">
              <i class="metismenu-icon pe-7s-bell"></i> <span>Live Activity</span>
            </a>
          </li>
          <li>
            <a href="javascript:void(0);" (click)="goToPage('/reports')" [class.mm-active]="currentUrl.includes('/reports')">
              <i class="metismenu-icon pe-7s-note2"></i> <span>Reports</span>
            </a>
          </li>
        </ng-container>

        <!--
          Ordered to follow how the data actually depends on itself, so setting the app up the
          first time reads top-to-bottom: define what a machine can BE (Machine Types), then the
          machines themselves, then products/steps that use those machines, then the people
          (Users) assigned to work on them, then what those people are allowed to do (Roles),
          then whatever's left over (Settings).
        -->
        <ng-container *ngIf="appState.isAdmin()">
          <li class="app-sidebar__heading">Configuration</li>
          <li>
            <a href="javascript:void(0);" (click)="goToPage('/machine-types')" [class.mm-active]="currentUrl.includes('/machine-types')">
              <i class="metismenu-icon pe-7s-albums"></i> <span>Machine Types</span>
            </a>
          </li>
          <li>
            <a href="javascript:void(0);" (click)="goToPage('/machines')" [class.mm-active]="currentUrl.includes('/machines')">
              <i class="metismenu-icon pe-7s-tools"></i> <span>Machines</span>
            </a>
          </li>
          <li>
            <a href="javascript:void(0);" (click)="goToPage('/products')" [class.mm-active]="currentUrl.includes('/products')">
              <i class="metismenu-icon pe-7s-box2"></i> <span>Products &amp; Workflow</span>
            </a>
          </li>
          <li>
            <a href="javascript:void(0);" (click)="goToPage('/operators')" [class.mm-active]="currentUrl.includes('/operators')">
              <i class="metismenu-icon pe-7s-users"></i> <span>Users</span>
            </a>
          </li>
          <li>
            <a href="javascript:void(0);" (click)="goToPage('/roles')" [class.mm-active]="currentUrl.includes('/roles')">
              <i class="metismenu-icon pe-7s-id"></i> <span>Manage Roles</span>
            </a>
          </li>
          <li>
            <a href="javascript:void(0);" (click)="goToPage('/settings')" [class.mm-active]="currentUrl.includes('/settings')">
              <i class="metismenu-icon pe-7s-config"></i> <span>Settings</span>
            </a>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
</div>
